<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Event
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Event"
      text="Create Event"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row> 
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Event Name"
              />
            </v-col>

            <v-col cols="6">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>
            
            <v-col cols="6">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="description"
                solo
                name="input-7-4"
                label="Description"
                placeholder="Event description"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="sharedFolderLink"
                v-validate="'required'"
                data-vv-name="sharedFolderLink"
                data-vv-as="shared folder link"
                :error-messages="errors.collect('sharedFolderLink')"
                solo
                name="input-7-4"
                label="Shared Folder Link"
                placeholder="Shared Folder Link"
              />
            </v-col>

            <v-col cols="12">
              <helper-image-input  
                v-model="image" 
                :max-size-in-mb="2"
                data-vv-name="image"
                field-name="image"
                accept-type=".jpg,.jpeg,.png"            
              >          
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add Image
                  </v-btn>
                  <span>
                    {{ image ? image.imageFile.name : 'No file chosen (.jpg/.png only)' }}
                  </span>
                </div>
              </helper-image-input>
              <span class="red--text text--lighten-1">{{ errors.first('image') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    components: {
      HelperImageInput: () => import('@/components/helper/ImageInput'),
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        description: null,
        image: null,
        startDateMenu: false,
        startDate: null,
        endDateMenu: false,
        endDate: null,
        sharedFolderLink: null,
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.endDate ? this.$moment(this.endDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$validator.reset()          
          this.$resetData()
        } 
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.events().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Event Created' })

                  this.setDialog(false)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      prepareFormData () {
        if (!this.image) {
          return {
            'name': this.name,
            'description': this.description,
            'start_date': this.startDate,
            'end_date': this.endDate,
            'original_folder_path': this.sharedFolderLink,
          }
        }

        this.image.formData.set('name', this.name)
        this.image.formData.set('description', this.description)
        this.image.formData.set('start_date', this.startDate)
        this.image.formData.set('end_date', this.endDate)
        this.image.formData.set('original_folder_path', this.sharedFolderLink)

        return this.image.formData
      },   
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.name = null
      },
      remove (array, item) {
        const index = array.indexOf(item.id)
        if (index >= 0) array.splice(index, 1)
      },
    },
  }
</script>

<style scoped>
.text-truncate{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
